var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.344 11.878C21.9575 11.878 21.622 12.1872 21.622 12.6V19.032C21.622 20.4447 20.516 21.574 19.08 21.574H4.89596C3.48327 21.574 2.35396 20.4681 2.35396 19.032V12.576C2.35396 12.1896 2.04473 11.854 1.63196 11.854C1.22035 11.854 0.909961 12.1644 0.909961 12.576V19.008C0.909961 21.1956 2.68435 22.97 4.87196 22.97H19.08C21.2676 22.97 23.042 21.1956 23.042 19.008V12.5776C23.0671 12.1852 22.7278 11.878 22.344 11.878Z",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9405 16.9313L11.9758 16.9668L12.0113 16.9314L15.9953 12.9474C16.2788 12.6638 16.2788 12.2242 15.9953 11.9406C15.7117 11.6571 15.2721 11.6571 14.9886 11.9406L12.6979 14.2313V1.752C12.6979 1.36556 12.3887 1.03 11.9759 1.03C11.5643 1.03 11.2539 1.34039 11.2539 1.752V14.2304L9.01146 11.9648L9.01127 11.9646C8.72775 11.6811 8.28809 11.6811 8.00456 11.9646C7.72105 12.2482 7.72104 12.6878 8.00453 12.9713C8.00454 12.9713 8.00455 12.9713 8.00456 12.9714L11.9405 16.9313Z",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.2e6c5846.svg";
export { ForwardRef as ReactComponent };